import React from "react";

interface V3ReviewsProps {
  translate: (key: string) => string;
}

const Star: React.FC<{ size?: number; color?: string }> = ({
  size = 12,
  color = "#00B67A",
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2l2.9 6.9L22 10l-5.5 4.8L18 22l-6-3.6L6 22l1.5-7.2L2 10l7.1-1.1z" />
  </svg>
);

const Stars: React.FC<{ size?: number; color?: string }> = ({ size, color }) => (
  <span className="upsell-v3__reviews-stars">
    {[0, 1, 2, 3, 4].map((i) => (
      <Star key={i} size={size} color={color} />
    ))}
  </span>
);

const V3Reviews: React.FC<V3ReviewsProps> = ({ translate }) => {
  // Reuse existing trustpilot copy as source of opinions.
  const reviews = [1, 2, 3].map((i) => ({
    quote: translate(`truspilot.opinion.text${i}`),
    author: translate(`truspilot.opinion.name${i}`),
    hero: i === 1,
  }));

  return (
    <section className="upsell-v3__reviews">
      <div className="upsell-v3__reviews-inner">
        {reviews.map((r, idx) => (
          <article
            key={idx}
            className={`upsell-v3__reviews-card${r.hero ? " upsell-v3__reviews-card--hero" : ""}`}
          >
            <div>
              <Stars size={14} color={r.hero ? "white" : "#00B67A"} />
              <p className="upsell-v3__reviews-quote">“{r.quote}”</p>
            </div>
            <div className="upsell-v3__reviews-author">— {r.author}</div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default V3Reviews;
